import React from "react";

import {
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    SelectInput,
    required,
} from "react-admin";

import {
    TableCell,
    TableRow,
} from "@material-ui/core";


const discreteChoices = [
    { id: "P", name: "Positive" },
    { id: "N", name: "Negative" }
]
export const DiscreteAntibioticInterpretationField = (props) => {
    const index = props.index;
    const DeleteButton = props.deleteButton;
    return (<TableRow
        key={index}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
        <TableCell component="th" scope="row">
            <ReferenceInput
                label="Antibiotico"
                source={`${props.source ?? 'antibiotics_discrete'}[${index}].id_antibiotic`}
                reference="antibiotics"
                validate={required()}
                filter={{ isDiscrete: true }}
            >
                <AutocompleteInput
                    resettable={true}
                    clearAlwaysVisible={true}
                    optionText="name"
                    suggestionLimit={10}
                />
            </ReferenceInput >
        </TableCell >
        <TableCell align="left">
            <SelectInput
                label="Interpretacion"
                source={`${props.source ?? 'antibiotics_discrete'}[${index}].mic_interpretation`}
                choices={discreteChoices}

            />
        </TableCell>
        <TableCell align="left">
            <TextInput
                source={`${props.source ?? 'antibiotics_discrete'}[${index}].notes`}
                label="Notes"
            />
        </TableCell>
        <DeleteButton index={index}></DeleteButton>
    </TableRow >);
}